import PropTypes from 'prop-types'
import Link from '@components/link'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Series from '@components/atoms/series'
import { PublishDate, PublishDateCard } from '@components/atoms'

import { CardXlRoot, VideoIcon } from './card-xl.styles'

const variants = {
  xl: {
    contentWidth: ['100%', '52%', '50%', '34%'],
    contentPadding: [2, 4],
    height: ['auto', 'auto', 460, 540],
  },
  lg: {
    contentWidth: ['100%', '50%'],
    contentPadding: [2, 2, 2.5],
    height: ['auto', 'auto', 420],
  },
}

const CardXl = (props) => {
  const {
    headline,
    cat,
    variant = 'xl',
    summary,
    image,
    sys,
    video,
  } = props

  const imageStyle = {
    backgroundImage: `url(${image && `${image.url}?h=360&w=640&fit=fill&fl=progressive&q=80`})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }

  const combinedSeries = cat && (cat.series || cat.category)
  const variantKey = variant || 'xl'

  return (
    <Link {...props} variant="card">
      <CardXlRoot
        flexDirection={['column', 'row', 'row']}
        height={variants[variantKey].height}
      >
        <Box
          position="relative"
          style={imageStyle}
          flexGrow={1}
        >
          {video && <VideoIcon data-testid="video-icon" />}
        </Box>

        <Box
          width={variants[variantKey].contentWidth}
          pt={[2, 3, 5]}
          px={variants[variantKey].contentPadding}
          pb={variants[variantKey].contentPadding}
          position="relative"
          display="flex"
          flexDirection="column"
        >
          {cat && <Series data-gtm-category={combinedSeries}>{combinedSeries}</Series>}

          <Typography variant="h5" gutterBottom data-gtm-story={headline}>{headline}</Typography>

          <Box display={{ xs: 'none', sm: 'block' }} color="grey.dark" flexGrow={1}>
            <Typography paragraph>{summary}</Typography>
          </Box>

          <PublishDateCard>
            <PublishDate publishedAt={sys && sys.publishedAt} />
          </PublishDateCard>
        </Box>
      </CardXlRoot>
    </Link>
  )
}

CardXl.propTypes = {
  headline: PropTypes.string,
  cat: PropTypes.shape({
    category: PropTypes.string,
    series: PropTypes.string,
  }),
  slug: PropTypes.string,
  summary: PropTypes.string,
  variant: PropTypes.oneOf(['xl', 'lg']),
  image: PropTypes.shape({
    description: PropTypes.string,
    url: PropTypes.string,
  }),
  video: PropTypes.shape({}),
  sys: PropTypes.shape({
    id: PropTypes.string,
    publishedAt: PropTypes.string,
  }),
}

export default CardXl
